import { Classroom } from '@/api/classroom'

const state = () => ({
  WebinarRequested: [],
  WebinarRequestedPagination: {},
  WebinarUserRequest: [],
  WebinarUserRequestPagination: {},
  WebinarIdRequest: 0,
  WebinarPlus: [],
  loadingWebinarPlus: false,
  messageWebinarPlus: '',
  isSuccessWebinarPlus: true,
  WebinarApproved: [],
  WebinarApprovedPagination: {},
})

const getters = {
  WebinarRequested: state => state.WebinarRequested,
  WebinarRequestedPagination: state => state.WebinarRequestedPagination,
  WebinarUserRequest: state => state.WebinarUserRequest,
  WebinarUserRequestPagination: state => state.WebinarUserRequestPagination,
  WebinarIdRequest: state => state.WebinarIdRequest,
  WebinarPlus: state => state.WebinarPlus,
  loadingWebinarPlus: state => state.loadingWebinarPlus,
  messageWebinarPlus: state => state.messageWebinarPlus,
  isSuccessWebinarPlus: state => state.isSuccessWebinarPlus,
  WebinarApproved: state => state.WebinarApproved,
  WebinarApprovedPagination: state => state.WebinarApprovedPagination,
}

const actions = {
  async fetchAllWebinarRequested({commit}, query = null) {
    let page = 1
    let perPage = 10
    if(query !== null) {
        page = query.page
        perPage = query.perPage
    }
    commit('setLoadingWebinarPlus', true)
    await Classroom.getAllWebinarRequested(perPage, page)
    .then(response => {
        commit('setWebinarRequested', response.data.data)
        const pagination = {
            total: response.data.pages.total,
            perPage: response.data.pages.per_page,
            page: response.data.pages.current_page,
            from: response.data.pages.from
        }
        commit('setWebinarRequestedPagination', pagination)
        commit('setLoadingWebinarPlus', false)
    })
    .catch(error => {
        console.log(error)
        commit('setLoadingWebinarPlus', false)
    })
  },

  async fetchUserRequestWebinar({commit}, query = null) {
    let page = 1
    let perPage = 10
    if (query !== null) {
      page = query.page
      perPage = query.perPage
    }
    commit('setLoadingWebinarPlus', true)
    await Classroom.getUserRequestWebinar(query.webinarId, perPage, page)
    .then(response => {
      commit('setWebinarUserRequest', response.data.data)
      const paginaton = {
        total: response.data.pages.total,
        perPage: response.data.pages.per_page,
        page: response.data.pages.current_page,
        from: response.data.pages.from,
      }
      commit('setWebinarUserRequestPagination', paginaton)
      commit('setLoadingWebinarPlus', false)
    })
    .catch(error => {
      console.log(error)
      commit('setLoadingWebinarPlus', false)
    })
  },

  async fetchWebinarApprovedByMentor({commit}) {
    commit('setLoadingWebinarPlus', true)
    await Classroom.getWebinarApprovedByMentor()
    .then(response => {
      commit('setWebinarApproved', response.data.data)
      const pagination = {
        total: response.data.pages.total,
        perPage: response.data.pages.per_page,
        page: response.data.pages.current_page,
        from: response.data.pages.from,
      }
      commit('setWebinarApprovedPagination', pagination)
      commit('setLoadingWebinarPlus', false)
    })
    .catch(error => {
      console.log(error)
      commit('setLoadingWebinarPlus', false)
    })
  },
}

const mutations = {
  setWebinarRequested: (state, list) => {
    state.WebinarRequested = list
  },
  setWebinarRequestedPagination: (state, pagination) => {
    state.WebinarRequestedPagination = pagination
  },
  setWebinarUserRequest: (state, user) => {
    state.WebinarUserRequest = user
  },
  setWebinarUserRequestPagination: (state, pagination) => {
    state.WebinarUserRequestPagination = pagination
  },
  setWebinarIdRequest: (state, id) => {
    state.WebinarIdRequest = id
  },
  setWebinarPlus: (state, webinar) => {
    state.WebinarPlus = webinar
  },
  setLoadingWebinarPlus: (state, loading) => {
    state.loadingWebinarPlus = loading
  },
  setMessageWebinarPlus: (state, message) => {
    state.messageWebinarPlus = message
  },
  setSuccessWebinarPlus: (state, status) => {
    state.isSuccessWebinarPlus = status
  },
  setWebinarApproved: (state, data) => {
    state.WebinarApproved = data
  },
  setWebinarApprovedPagination: (state, pagination) => {
    state.WebinarApprovedPagination = pagination
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}